import { Component, DestroyRef, ViewChild, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute } from '@angular/router'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { PendingChangeOrdersComponent } from './pending-change-orders.component'
import {
    PcoDashboardDrillthrough,
    PendingChangeOrdersDashboardComponent,
} from './pending-change-orders-dashboard.component'

@Component({
    templateUrl: './pending-change-orders-page.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        PendingChangeOrdersDashboardComponent,
        PendingChangeOrdersComponent,
    ],
})
export class PendingChangeOrdersPageComponent extends BaseComponent {
    private route = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)

    @ViewChild(PendingChangeOrdersDashboardComponent)
    dashboard?: PendingChangeOrdersDashboardComponent

    @ViewChild(PendingChangeOrdersComponent)
    list?: PendingChangeOrdersComponent

    activeTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1

        this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            if (params.get('openPcoId')) {
                this.activeTab = 1
            }
        })

        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    onViewRecords(event: PcoDashboardDrillthrough) {
        this.activeTab = 1
        setTimeout(() => {
            this.list?.applyDashboardFilter(event)
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsPendingChangeOrdersView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
